<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig'
const sysStore = useSystemConfigStoreHook()
const { t } = useI18n()
const partnerslist= ref(sysStore.portalConfig.partnerList)
const sectionRef = ref<HTMLElement | null>(null);
  let observer: IntersectionObserver | undefined; // ✅ 提前定义 observer
onBeforeUnmount(() => {
  observer?.disconnect(); // ✅ 这里就能访问到上面的 observer
});
onMounted(async () => {
  await nextTick();
  // 所有需要动画的元素
  const els =
    sectionRef.value?.querySelectorAll<HTMLElement>("[data-anim]") ?? [];
  const OBS_IN = 0.1; // 可见触发进场
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const el = e.target as HTMLElement;
        // 进场
        if (e.intersectionRatio >= OBS_IN) {
          el.dataset.inview = "true";
        }
        // 完全离场才复原
        else if (e.intersectionRatio === 0) {
          el.dataset.inview = "false";
        }
      });
    },
    {
      rootMargin: "0px 0px -15% 0px", // 出屏 15 % 才算离场
      threshold: [0, OBS_IN],
    }
  );
  els.forEach((el) => observer.observe(el));
});
</script>

<template>
  <section ref="sectionRef" class="bg-white py-[8.6rem]">
    <div class="max-width mx-auto flex flex-col items-center">
      <h2 class="text-[3rem] font-[600] text-[#000000]" data-anim style="--d:100ms">
        {{ t('page7.heading.prefix') }}
        <span class="text-main-primary">{{ t('page7.heading.highlight') }}</span>
        {{ t('page7.heading.suffix') }}
      </h2>

      <!-- 卡片列表 -->
      <div data-anim style="--d:150ms" class="flex justify-center gap-x-[1.375rem] gap-y-6 mt-[3.56rem]">
        <div v-for="(p,index) in partnerslist" :key="index"
          class="partner-card bg-[#FAFAFA] rounded-[0.5rem] w-[13.5rem] h-[4.9rem] flex justify-center items-center">
          <img :src="p" class="w-[9.3125rem] h-[2.5rem] object-contain" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* hover 放大 */
.partner-card {
  transition: transform 0.3s ease;
}

.partner-card:hover {
  transform: scale(1.05);
}
[data-anim] {
  --d: 0ms;                                
  opacity: 0;
  transform: translateY(40px);
  transition:
    opacity 0.7s cubic-bezier(.25,.8,.25,1) var(--d),
    transform 0.7s cubic-bezier(.25,.8,.25,1) var(--d);
  will-change: opacity, transform;
}
[data-anim][data-inview="true"] {
  opacity: 1;
  transform: translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  [data-anim] {
    transition: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
</style>